import Feature4_2_morph from './Feature4_2_morph'
export default Feature4_2_morph
